import React from "react";
import {connect} from "react-redux";
import {canReadShipping, canReadSales} from "../../../reducers/authReducer";
import ShippingNotificationsList from "./ShippingNotificationsList";
import SalesNotificationsList from "./SalesNotificationsList";
import Conditional from "../../../components/Conditional";
import DashboardPanel from "../../../components/DashboardPanel";

const PickupAndSalesDashboard = (props) => {
  return (
    <React.Fragment>
      <Conditional show={props.canReadShipping}>
        <DashboardPanel title="Shipment Pickups" withBorder>
          <ShippingNotificationsList />
        </DashboardPanel>
      </Conditional>

      <Conditional show={props.canReadSales}>
        <DashboardPanel title="Sales Orders" withBorder>
          <SalesNotificationsList />
        </DashboardPanel>
      </Conditional>
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    canReadShipping: canReadShipping(state.get("auth")),
    canReadSales: canReadSales(state.get("auth"))
  }
}

export default connect(mapStateToProps, {})(PickupAndSalesDashboard);
